/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/ResourceLocation/Active/Post
 * @desc Active node component for ResourceLocation
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { ICONS } from 'labstep-web/constants/icons';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';

export const FilterPostNewIndexResourceLocationActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const filter = new PostFilter(
    [['guid', PostFilterComparison.eq]],
    'resourceLocation',
  );

  const { guid: guidAttribute } = filter.getAttributeValues(node);

  const guid = guidAttribute?.value;

  if (!guid) {
    return null;
  }

  return (
    <EntityReadEntityContainer
      entityName={ResourceLocation.entityName}
      id={guid}
    >
      {({ entity }): React.ReactElement | null =>
        entity ? (
          <RemoveLabel
            icon={ICONS.resource_location.primary}
            name={entity.name}
            onRemoveClick={onRemoveClick}
          />
        ) : null
      }
    </EntityReadEntityContainer>
  );
};
